import React, { useEffect, useState } from 'react'
import { IShipmentMaterial, IShipmentMaterialSearchRequest, IShipmentMaterialSearchResult } from '../../types/shipment';

import { UtilityService } from '../../services/utilityService';
import Spinner from '../spinner';
import { AppConfig } from '../../config/appConfig';
import { Button } from '@mui/material';

export interface IShippedMaterialTableProps {
	data: IShipmentMaterialSearchResult;
	bol?: string;
	customer?: string;
	vendor?: string;
	status?: string;
	isAwaitingResultSet?: boolean;
	update?: Function;
}

const ShippedMaterialTable: React.FunctionComponent<IShippedMaterialTableProps> = ({ data, bol, customer, vendor, status, isAwaitingResultSet, update }) => {
	const [dataView, setDataView] = useState<IShipmentMaterial[]>([]);
	const [sortField, setSortField] = useState('');
	const [sortAscending, setSortAscending] = useState(true);
	const [pageIndex, setPageIndex] = useState(0);
	const [pageSize, setPageSize] = useState(AppConfig.shippingMaterialsDefaultPageSize);
	const [searchRequest, setSearchRequest] = useState({
		pageIndex: 0,
		pageSize: pageSize,
	});

	const handleHeaderClick = (field: string) => {
		if (sortField == field) {
			setSortAscending(!sortAscending);
		}
		else {
			setSortAscending(true);
			setSortField(field);
		}
	}

	const handlePageBack = () => {
		if (pageIndex > 0) {
			const request = {...searchRequest, ['pageIndex']: pageIndex - 1}
			setSearchRequest(request);
		}
	}

	const handlePageForward = () => {
		if (pageIndex < (Math.floor(data?.totalMatchingRecords / pageSize))) {
			const request = {...searchRequest, ['pageIndex']: pageIndex + 1};
			setSearchRequest(request);
		}
	}

	useEffect(() => {
		setPageIndex(searchRequest.pageIndex);
		setPageSize(searchRequest.pageSize);

		update(searchRequest);
	}, [searchRequest]);

	useEffect(() => {
		if (data?.totalMatchingRecords) {
			let newData = data.records.filter((item) => {
				// if (bol && bol != "All" && item.id?.toString() != bol) {
				// 	return false;
				// }
				// if (customer && customer != "All" && item.customerName != customer) {
				// 	return false;
				// }
				// if (vendor && vendor != "All" && item.vendorName != vendor) {
				// 	return false;
				// }
				// TODO: Status is a combination of fields here. Wire it up once they are all in the model
				// if (status && status != "All" && item.details?.status != status) {
				// 	return false;
				// }
				return true;
			}).slice();

			if (sortField) {
				switch (sortField) {
					// case "customer": {
					// 	newData.sort((a, b) => UtilityService.compareStrings(a.customerName, b.customerName));
					// 	break;
					// }
					// case "vendor": {
					// 	newData.sort((a, b) => UtilityService.compareStrings(a.vendorName, b.vendorName));
					// 	break;
					// }
					case "plantweight": {
						newData.sort((a, b) => UtilityService.compareNumbers(a.plantAmount, b.plantAmount));
						break;
					}
					case "vendorweight": {
						newData.sort((a, b) => UtilityService.compareNumbers(a.vendorAmount, b.vendorAmount));
						break;
					}
					// case "requestdate": {
					// 	newData.sort((a, b) => UtilityService.compareStrings(a.scheduledPickupDate.toString(), b.scheduledPickupDate.toString()));
					// 	break;
					// }
					// case "pickupdate": {
					// 	newData.sort((a, b) => UtilityService.compareStrings(a.pickupDate.toString(), b.pickupDate.toString()));
					// 	break;
					// }
					// case "status": {
					// 	newData.sort((a, b) => UtilityService.compareStrings(a.details?.status, b.details?.status));
					// 	break;
					// }
					default: {
						newData.sort((a, b) => UtilityService.compareNumbers(a.id, b.id));
						break;
					}
				}
				if (!sortAscending) newData.reverse();
			}			

			setDataView(newData);
		}
	}, [data, bol, customer, vendor, status, sortField, sortAscending])

	return (
		<div className="results-table">
			<div className="data">
			<Spinner dependency={isAwaitingResultSet} text="Loading Shipped Materials...">
				{dataView?.length > 0 ?
					(
						dataView?.map((item, index) => (
							<>
								<div className="headers">
									<div className="material-col">
										<p>
											Material
										</p>
									</div>
									<div className="amount-col">
										<p>
											Amount
										</p>
									</div>
									<div className="unit-col">
										<p>
											Unit
										</p>
									</div>
									<div className="credit-col">
										<p>
											Credit
										</p>
									</div>
									<div className="per-col">
										<p>
											Per
										</p>
									</div>
									<div className="total-col">
										<p>
											Total Credit
										</p>
									</div>
								</div>
								<div className="row" key={item.id}>
									<div className="plant">
										<div className="material-col">
											<p className="location">Plant</p>
											<p className="material">{item.plantMaterialName}</p>
										</div>
										<div className="amount-col"><p>{item.plantAmount}</p></div>
										<div className="unit-col"><p>{item.plantUOMName}</p></div>
										<div className="credit-col"><p>${item.plantCreditPerUnit}</p></div>
										<div className="per-col"><p>{item.plantCreditUnitName}</p></div>
										<div className="total-col"><p>${item.plantCreditTotal}</p></div>
									</div>
									<div className="vendor">
										<div className="material-col">
											<p className="location">Vendor</p>
											<p className="material">{item.vendorMaterialName}</p>
										</div>
										<div className="amount-col"><p>{item.vendorAmount}</p></div>
										<div className="unit-col"><p>{item.vendorUOMName}</p></div>
										<div className="credit-col"><p>${item.vendorCreditPerUnit}</p></div>
										<div className="per-col"><p>{item.vendorCreditUnitName}</p></div>
										<div className="total-col"><p>${item.vendorCreditTotal}</p></div>
									</div>
								</div>
							</>
						))
					) :
					(
						<div className="no-results">0 results</div>
					)
				}
				</Spinner>
			</div>
			<div className="pager">
				{data?.records.length > 0 &&
					<>
						<div className="pager-button"><Button variant="outlined" fullWidth={true} disabled={isAwaitingResultSet || pageIndex <= 0} onClick={handlePageBack}>Previous</Button></div>
						<div className="pager-text">{`${(pageIndex * pageSize) + 1} to ${Math.min((pageIndex * pageSize) + pageSize, data?.totalMatchingRecords)} of ${data?.totalMatchingRecords}`}</div>
						<div className="pager-button"><Button variant="outlined" fullWidth={true} disabled={isAwaitingResultSet || ((pageIndex + 1) * pageSize) > data?.totalMatchingRecords} onClick={handlePageForward}>Next</Button></div>
					</>
				}
			</div>
		</div>
	)
}

export default ShippedMaterialTable;